import './page/ap-pdfs-check';
import deDE from './snippet/de-DE';
import enGB from './snippet/en-GB';

Shopware.Module.register('ap-pdfs', {
    // configuration here
    type: 'plugin',
    name: 'Alphaplan Connector PDFs',
    title: 'ap-pdfs.general.titleTextModule',
    description: 'ap-pdfs.general.descriptionTextModule',
    icon: 'alphaplan-icon',
    color: '#ff3d58',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },
    routes: {
        check: {
            component: 'ap-pdfs-check',
            path: 'check'
        }
    },
    navigation: [{
        id: 'ap-pdf',
        label: 'ap-pdfs.general.titleTextModule',
        color: '#ff3d58',
        path: 'ap.pdfs.check',
        position: 120,
        parent: 'ap-connector'
    }]

});
